import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad2CBlue2ARed = () => <CrossRoad coords="1338.000000, 883.000000"/>;
export default CrossRoad2CBlue2ARed;
